export default "__VITE_ASSET__58f5acd3__"